import { render, staticRenderFns } from "./SendContract.vue?vue&type=template&id=6951fcba&scoped=true"
import script from "./SendContract.vue?vue&type=script&lang=js"
export * from "./SendContract.vue?vue&type=script&lang=js"
import style0 from "./SendContract.vue?vue&type=style&index=0&id=6951fcba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6951fcba",
  null
  
)

export default component.exports